import type { TripTransportLegTimes } from '~/services/engine-ts';

export type LegTimeOption = {
  departureTime: string;
  arrivalTime: string;
};

export const legTimeOptionKey = (option: LegTimeOption) => `${option.departureTime}-${option.arrivalTime}`;

export const alternativeLegTimeOptions = (
  times: TripTransportLegTimes[] | undefined,
  itemId: number
): LegTimeOption[] => times?.find((entry) => entry.itemId === itemId)?.alternativeTimes ?? [];

export const hasAlternativeLegTimes = (options: LegTimeOption[], current: LegTimeOption | null): boolean => {
  if (current === null) return options.length > 0;
  const currentKey = legTimeOptionKey(current);
  return options.some((option) => legTimeOptionKey(option) !== currentKey);
};
